var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9441 6.65758C17.9568 6.83523 17.9568 7.01293 17.9568 7.19059C17.9568 12.6093 13.8325 18.853 6.29441 18.853C3.97207 18.853 1.81473 18.1804 0 17.0129C0.329961 17.051 0.647187 17.0637 0.989844 17.0637C2.90605 17.0637 4.67004 16.4165 6.07867 15.3124C4.27664 15.2743 2.76648 14.0941 2.24617 12.4698C2.5 12.5078 2.75379 12.5332 3.02031 12.5332C3.38832 12.5332 3.75637 12.4824 4.09898 12.3936C2.22082 12.0129 0.812148 10.3632 0.812148 8.37078V8.32004C1.35781 8.62461 1.99238 8.81496 2.66492 8.84031C1.56086 8.10426 0.837539 6.84793 0.837539 5.4266C0.837539 4.6652 1.04055 3.96723 1.3959 3.35809C3.41367 5.84539 6.44668 7.46973 9.84766 7.64742C9.78422 7.34285 9.74613 7.02562 9.74613 6.70836C9.74613 4.44945 11.5736 2.60938 13.8451 2.60938C15.0253 2.60938 16.0913 3.1043 16.84 3.90379C17.7664 3.72613 18.6547 3.38348 19.4416 2.91395C19.137 3.86574 18.4898 4.66523 17.6395 5.17281C18.4644 5.08402 19.2639 4.85555 19.9999 4.53832C19.4416 5.35047 18.7436 6.07379 17.9441 6.65758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/twitter1.40b3b19967aef63451b4997560f039e9.svg";
export { ForwardRef as ReactComponent };